module.exports = __webpack_public_path__ + "static/media/lv_trophy.7e7267a3.png";